<template>
  <v-dialog :value="value" persistent width="800">
    <v-card class="grey lighten-3">
      <v-toolbar flat dark color="#00aff0">
        <v-toolbar-title> Edit {{ attr.name }} </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('update:value', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="pa-3 ma-0">
        <v-row align="center" justify="center">
          <v-col cols="3">
            <component
              :is="attrComponent"
              :attr="attr"
              :attrvalue="attrvalue"
              :attrvalues="attrvalues"
              @save-attr="setNewValue"
              no-focus
            >
            </component>
          </v-col>
          <v-col v-if="!attrIsFeeAmount" cols="3">
            <v-text-field
              v-model="feeAmount"
              label="Fee Amount"
              type="number"
              prefix="$"
              outlined
              dense
              hide-details
              background-color="#fff"
              :rules="[isValidFee]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="billingCadence"
              :items="availableBillingCadences"
              label="Billing Cadence"
              :item-text="'name'"
              :item-value="'id'"
              outlined
              dense
              hide-details
              background-color="#fff"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
      <v-divider />
      <v-toolbar flat class="grey lighten-3">
        <v-spacer />
        <v-btn
          color="green"
          class="white--text"
          :disabled="saveBtnDisabled || (isTruthy && (!billingCadence || !feeAmount))"
          @click="valueExists ? updateAttributeValue() : saveAttributeValue()">
            {{ valueExists ? 'Update' : 'Save' }}
          <v-icon right>
            {{ valueExists ? 'mdi-update' : 'mdi-content-save-outline' }}
          </v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>
<script>
import attrApi from '@/axios/party-attribute-endpoint'
import { displayAlert } from '@/mixins/alert'
import { utils } from '@/mixins/utils'
import { userAccess } from '@/mixins/user-access'
import { formValidation } from '@/mixins/formvalidation'
export default {
  name: 'FeeInput',
  data: () => ({
    newVal: null,
    newValObject: null,
    saveBtnDisabled: false,
    feeAmount: null,
    billingCadence: null
  }),
  props: ['value', 'attr', 'attrvalue', 'attrvalues', 'attrComponent', 'timeSensitive'],
  mixins: [displayAlert, userAccess, formValidation, utils],
  created () {
    this.newVal = this.isKeyValue ? this.attrvalue?.attr_key_value?.id : this.attrvalue?.value
    if (this.isTruthy) {
      this.feeAmount = this.attrvalue?.fee_amount ? this.attrvalue?.fee_amount : this.defaultFeeAmount
      this.billingCadence = this.attrvalue?.billing_cadence_id ? this.attrvalue?.billing_cadence_id : this.attr?.default_billing_cadence.id
    }
  },
  computed: {
    defaultFeeAmount() {
      if (this.isKeyValue && this.attr.id === 'NEW_ITEM_TIER' && this.newValObject?.name) {
        const matches = this.newValObject.name.match(/(\d+)$/)
        if (matches?.length > 0) {
          return matches[0]
        }
      }
      return this.attr?.default_fee_amount
    },
    attrIsFeeAmount () {
      return ['IPRO_FEE'].includes(this.attr.id)
    },
    valueExists () {
      return Boolean(this.attr && this.attrvalue)
    },
    saveButtonDisabled () {
      return !this.billingCadence || !this.feeAmount
    },
    availableBillingCadences () {
      return this.$store.getters.billingCadences
    },
    isTruthy () {
      return Boolean((this.attr.data_type.constant === 'BOOLEAN' && this.newVal === 'True') || (this.newVal && this.newVal !== 'False'))
    },
    isFalsy () {
      return Boolean((this.attr.data_type.constant === 'BOOLEAN' && this.newVal === 'False') || !this.newVal)
    },
    isKeyValue() {
      return this.attr.data_type.constant === 'KEY_VALUE'
    },
  },
  methods: {
    async updateAttributeValue() {
      this.saveBtnDisabled = true
      if (this.isTruthy && (!this.billingCadence || !this.feeAmount)) {
        this.saveBtnDisabled = false
        return this.emitAlert(true, 'warning', 'Please fill out required fields.')
      }
      var attrValue = {
        attr_id: this.attr.id,
        attr_key_value_id: null,
        party_id: this.$route.query.id,
        updated_by: this.$store.getters.email,
        billing_cadence_id: this.billingCadence,
        fee_amount: parseFloat(this.formatCurrency(this.feeAmount)),
        value: this.attrvalue.value
      }
      if (this.isKeyValue) {
        attrValue.attr_key_value_id = this.newVal ? this.newVal : null
      } else {
        attrValue.value = this.newVal ? this.newVal : this.attrvalue.value
      }
      try {
        await attrApi.attributeValue.put(this.attrvalue.id, attrValue)
        this.$emit('refresh-values')
        this.emitAlert(true, 'success', `${this.attr.name} has been successfully updated.`)
        this.saveBtnDisabled = false
        this.$emit('update:value', false)
      } catch (err) {
        this.$emit('refresh-values')
        this.handleError(err)
        this.saveBtnDisabled = false
      }
    },
    async saveAttributeValue() {
      this.saveBtnDisabled = true
      if (!this.billingCadence || !this.feeAmount) {
        this.saveBtnDisabled = false
        return this.emitAlert(true, 'warning', 'Please fill out required fields.')
      }
      var attrValue = {
        attr_id: this.attr.id,
        attr_key_value_id: null,
        party_id: this.$route.query.id,
        created_by: this.$store.getters.email,
        billing_cadence_id: this.billingCadence,
        fee_amount: parseFloat(this.formatCurrency(this.feeAmount)),
        value: null
      }
      if (this.isKeyValue) {
        attrValue.attr_key_value_id = this.newVal ? this.newVal : null
      } else {
        attrValue.value = this.newVal ? this.newVal : null
      }
      try {
        await attrApi.attributeValue.post(attrValue)
        this.$emit('refresh-values')
        this.emitAlert(true, 'success', `${this.attr.name} has been successfully saved.`)
        this.saveBtnDisabled = false
        this.$emit('update:value', false)
      } catch (err) {
        this.$emit('refresh-values')
        this.handleError(err)
        this.saveBtnDisabled = false
      }
    },
    setNewValue(val) {
      this.newVal = this.isKeyValue ? val.id : val
      this.newValObject = this.isKeyValue ? val : null
      if (this.isTruthy) {
        if (this.attrIsFeeAmount) {
          this.feeAmount = parseFloat(val) || 0
        } else if (this.attr.id === 'NEW_ITEM_TIER' && this.feeAmount !== this.defaultFeeAmount) {
          this.feeAmount = this.defaultFeeAmount
        } else {
          this.feeAmount = this.attrvalue?.fee_amount ? this.attrvalue?.fee_amount : this.defaultFeeAmount
        }
        this.billingCadence = this.attrvalue?.billing_cadence_id ? this.attrvalue?.billing_cadence_id : this.attr?.default_billing_cadence.id
      } else if (this.isFalsy || !this.newVal) {
        this.feeAmount = null
        this.billingCadence = null
      }
    }
  }
}
</script>
